var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible, width: "80%", offset: 0 },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "tab-container" }, [
            _c(
              "div",
              {
                staticClass: "tab",
                class: !_vm.showInquiry ? "active1" : "",
                on: {
                  click: function ($event) {
                    _vm.showInquiry = false
                  },
                },
              },
              [_vm._v("报价信息")]
            ),
            _c(
              "div",
              {
                staticClass: "tab",
                class: _vm.showInquiry ? "active1" : "",
                on: {
                  click: function ($event) {
                    _vm.showInquiry = true
                  },
                },
              },
              [_vm._v("询价详情")]
            ),
          ]),
          _c("div", { staticClass: "main-area" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showInquiry,
                    expression: "!showInquiry",
                  },
                ],
              },
              [
                _c("div", { staticClass: "quote-card" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex-between",
                      staticStyle: { "margin-bottom": "16px" },
                    },
                    [
                      _c(
                        "h3",
                        {
                          staticStyle: {
                            "font-size": "20px",
                            color: "#142433",
                          },
                        },
                        [
                          _vm._v(
                            "报价方案 · " + _vm._s(_vm.budget.resourceNameCn)
                          ),
                        ]
                      ),
                      _c("span", { staticClass: "status-sent" }, [
                        _c("i", { staticClass: "fas fa-check-circle" }),
                        _vm._v(
                          _vm._s(
                            _vm.item.isSend == 1
                              ? "已发送报价给客户"
                              : _vm.item.isSend == 1 && _vm.isOrder == 1
                              ? "客户已购买"
                              : "已撤回报价"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c("div", { staticClass: "cost-summary" }, [
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v("成本"),
                      ]),
                      _c("span", { staticClass: "summary-value" }, [
                        _vm._v("¥" + _vm._s(_vm.budgetDetail.totalPrice)),
                      ]),
                    ]),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v("报价"),
                      ]),
                      _c("span", { staticClass: "summary-value" }, [
                        _vm._v("¥" + _vm._s(_vm.budgetDetail.saleTotalPrice)),
                      ]),
                    ]),
                    _c("div", { staticClass: "summary-item" }, [
                      _c("span", { staticClass: "summary-label" }, [
                        _vm._v("利润"),
                      ]),
                      _c("span", { staticClass: "profit-badge" }, [
                        _c("i", { staticClass: "fas fa-chart-line" }),
                        _vm._v(
                          " ¥" +
                            _vm._s(
                              (
                                _vm.budgetDetail.saleTotalPrice -
                                _vm.budgetDetail.totalPrice
                              ).toFixed(2)
                            )
                        ),
                      ]),
                    ]),
                  ]),
                  _c("div", { staticClass: "action-group" }, [
                    _vm.item.isSend != 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.saveQutation },
                          },
                          [
                            _c("i", { staticClass: "fas fa-check-circle" }),
                            _vm._v(" 保存报价"),
                          ]
                        )
                      : _vm._e(),
                    _vm.item.isSend == 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.sendInquiry },
                          },
                          [
                            _c("i", { staticClass: "fas fa-undo-alt" }),
                            _vm._v(" 撤回"),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            on: { click: _vm.sendInquiry },
                          },
                          [
                            _c("i", { staticClass: "fas fa-paper-plane" }),
                            _vm._v(" 发送报价"),
                          ]
                        ),
                  ]),
                  _c("table", { staticClass: "quote-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v("产品名称")]),
                        _c("th", [_vm._v("使用时间")]),
                        _c("th", [_vm._v("数量")]),
                        _c("th", [_vm._v("成本单价")]),
                        _c("th", [_vm._v("成本小计")]),
                        _c("th", [_vm._v("报价单价")]),
                        _c("th", [_vm._v("报价小计")]),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.budgetDetail.budgetList, function (tt, index) {
                        return _c("tr", { key: index }, [
                          _c("td", [
                            _c("span", { staticClass: "room-tag" }, [
                              _vm._v(_vm._s(tt.productName)),
                            ]),
                          ]),
                          _c("td", [_vm._v(_vm._s(tt.stayDateStr))]),
                          _c("td", [_vm._v(_vm._s(tt.stockNumber))]),
                          _c("td", [
                            _vm._v(_vm._s(tt.currency) + _vm._s(tt.stockPrice)),
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(tt.currency) +
                                _vm._s(tt.stockPrice * tt.stockNumber)
                            ),
                          ]),
                          _vm.item.isSend == 1
                            ? _c("td", [
                                _vm._v(_vm._s(tt.currency) + _vm._s(tt.ratio)),
                              ])
                            : _c(
                                "td",
                                [
                                  _vm._v(_vm._s(tt.currency) + " "),
                                  _c("el-input", {
                                    staticClass: "price-input",
                                    staticStyle: { width: "100px" },
                                    attrs: { type: "number" },
                                    model: {
                                      value: tt.ratio,
                                      callback: function ($$v) {
                                        _vm.$set(tt, "ratio", $$v)
                                      },
                                      expression: "tt.ratio",
                                    },
                                  }),
                                ],
                                1
                              ),
                          _c("td", [
                            _vm._v(
                              _vm._s(tt.currency) +
                                _vm._s((tt.ratio * tt.stockNumber).toFixed(2))
                            ),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showInquiry,
                    expression: "showInquiry",
                  },
                ],
              },
              [
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c("div", { staticClass: "inquiry-detail-card" }, [
                    _c("div", { staticClass: "trip-header" }, [
                      _c("div", [
                        _c(
                          "h3",
                          {
                            staticStyle: {
                              "font-size": "20px",
                              color: "#142433",
                              "margin-bottom": "12px",
                            },
                          },
                          [_vm._v("酒店询价")]
                        ),
                        _c("div", { staticClass: "client-info" }, [
                          _c("i", { staticClass: "far fa-user" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.item.createName) +
                              " · 提出时间 " +
                              _vm._s(
                                _vm.dateFormatYMDHM(_vm.item.createTime, "-")
                              )
                          ),
                        ]),
                      ]),
                      _c("div", [
                        _c("span", { staticClass: "status-sent" }, [
                          _vm._v(
                            _vm._s(
                              _vm.item.isSend == 1
                                ? "已发送报价给客户"
                                : _vm.item.isSend == 1 && _vm.isOrder == 1
                                ? "客户已购买"
                                : "已撤回报价"
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "grid",
                          "grid-template-columns": "1fr 1fr",
                          gap: "24px",
                        },
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "18px" } },
                            [
                              _c("strong", [_vm._v("人数：")]),
                              _vm._v(_vm._s(_vm.item.peopleNumber)),
                            ]
                          ),
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "18px" } },
                            [
                              _c("strong", [_vm._v("行程：")]),
                              _vm._l(
                                _vm.item.planInfo,
                                function (item2, index) {
                                  return _c("span", { key: index }, [
                                    _vm._v(_vm._s(item2) + " "),
                                    _vm.item.planInfo &&
                                    index != _vm.item.planInfo.length - 1
                                      ? _c("span", [_vm._v(" · ")])
                                      : _vm._e(),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                          _c(
                            "div",
                            [
                              _c("strong", [_vm._v("需求：")]),
                              _vm._l(
                                _vm.item.needDetail,
                                function (item2, index) {
                                  return _c("span", { key: index }, [
                                    _vm._v(_vm._s(item2) + " "),
                                    _vm.item.needDetail &&
                                    index != _vm.item.needDetail.length - 1
                                      ? _c("span", [_vm._v(" · ")])
                                      : _vm._e(),
                                  ])
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]
                    ),
                    _c("div", { staticClass: "budget-box" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-weight": "600",
                            "margin-bottom": "14px",
                          },
                        },
                        [_vm._v("预算明细")]
                      ),
                      _c(
                        "div",
                        { staticClass: "room-locked" },
                        _vm._l(_vm.item.hotelRoomList, function (item1, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "room-tag" },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(item1.hotelRoomName) +
                                    " · " +
                                    _vm._s(item1.roomNumber) +
                                    "间  "
                                ),
                              ]),
                              _c("span", [
                                _vm._v(
                                  "锁死预算 " +
                                    _vm._s(_vm.item.currency) +
                                    _vm._s(_vm.item.roomBudget) +
                                    "/间/晚"
                                ),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "record-container" }, [
                    _c("div", { staticClass: "record-header" }, [
                      _c("h2", [_vm._v("操作记录")]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "record-list" },
                      _vm._l(_vm.item.oprationLogs, function (item1, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "record-item" },
                          [
                            _c("div", { staticClass: "record-top" }, [
                              _c("span", { staticClass: "operator" }, [
                                _vm._v(_vm._s(item1.createName)),
                              ]),
                              _c("span", { staticClass: "record-time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.dateFormatYMDHMS(item1.createTime, "-")
                                  )
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "record-meta" }, [
                              _c("span", { staticClass: "meta-item" }, [
                                _vm._v(_vm._s(item1.oprationContent)),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
              ]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }